<template>
<div>

  <breadcrumb></breadcrumb>

  <div class="row">
    <div class="col">
      <form v-on:submit.prevent="save" autocomplete="off">
        <div class="form-group">
          <label for="name">Nome</label>
          <input v-model="form.name" type="text" class="form-control" id="name" placeholder="">
        </div>

        <!--<div class="form-group">
          <label for="login">Login</label>
          <input autocomplete="off" v-model="form.login" type="text" class="form-control" id="login" placeholder="">
        </div>-->

        <div class="form-group">
          <label for="email">Email</label>
          <input v-model="form.email" type="email" class="form-control" id="email" placeholder="">
        </div>

        <div class="form-group">
          <label for="role">Role</label>
          <select name="role" id="role" class="form-control" v-model="form.role">
            <option value="" disabled="true">--select--</option>
            <option value="admin">Administrador</option>
            <option value="usuario">Usuario</option>
          </select>
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <input autocomplete="new-password" v-model="form.password" type="password" class="form-control" id="password" @change="passwordChanged()" placeholder="">
        </div>

        <div class="form-group">
          <label for="passwordConfirm">Confirm Password</label>
          <input autocomplete="new-password" v-model="form.passwordConfirm" type="password" class="form-control" id="passwordConfirm" placeholder="">
        </div>

        <div class="form-group">
          <label for="qtdDays">Quantidade de dias</label>
          <input v-model="form.qtdDays" @change="atualizaData" type="text" class="form-control" id="qtdDays" placeholder="">
        </div>

        <div class="form-group">
          <label for="expiraEm">Expira em</label>
          <input v-model="form.expiraEm" type="date" class="form-control" id="expiraEm" placeholder="">
        </div>

        <hr>
        
        <div class="row">
          <div class="form-group col-md-3">
            <label for="sexo">Sexo</label>
            <div class="form-check">
              <input @change="getCotas();" type="radio" name="sexo" id="masculino" class="form-check-input" value="10" v-model="form.form.sexo">
              <label for="masculino" class="form-check-label">Masculino</label>
            </div>
            <div class="form-check">
              <input @change="getCotas();" type="radio" name="sexo" id="feminino" class="form-check-input" value="0" v-model="form.form.sexo">
              <label for="feminino" class="form-check-label">Feminino</label>
            </div>
          </div>
          
          <div class="form-group col-md-3">
            <label for="peso">Peso (kg)</label>
            <input @change="getCotas();" type="number" name="peso" id="peso" step="0.01" v-model="form.form.peso" class="form-control form-control-sm" placeholder="">
          </div>

          <div class="form-group col-md-3">
            <label for="altura">Altura (cm)</label>
            <input @change="getCotas();" type="number" name="altura" id="altura" step="0.01" v-model="form.form.altura" class="form-control form-control-sm" placeholder="">
          </div>

          <div class="form-group col-md-3">
            <label for="cintura">Cintura (cm)</label>
            <input @change="getCotas();" type="number" name="cintura" id="cintura" step="0.01" v-model="form.form.cintura" class="form-control form-control-sm" placeholder="">
            <button type="button">calcular cotas</button>
          </div>

          <div class="form-group col-md-3">
            <label for="mais">Periodo que mais come</label>
            <select @change="getCotas()" v-model="form.form.mais" name="mais" id="mais" class="form-control form-control-sm">
              <option value="0">Manhã</option>
              <option value="1">Tarde</option>
              <option value="2">Noite</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="menos">Periodo que menos come</label>
            <select @change="getCotas()" v-model="form.form.menos" name="menos" id="menos" class="form-control form-control-sm">
              <option value="0">Manha</option>
              <option value="1">Tarde</option>
              <option value="2">Noite</option>
            </select>
          </div>

          <div class="col-md-12">
            <pre>
            Manhã:{{this.form.form.manha}}
            Tarde:{{this.form.form.tarde}}
            Noite:{{this.form.form.noite}}
          </pre>
          </div>
         
        </div>


        <br>

        <p>
        Total Cotas: {{getTotalCotas() > 0 ? getTotalCotas() : 'Não calculado'}}
        </p>

        <div class="form-group">
          <router-link to="/users" class="btn btn-danger">Cancelar</router-link>
          <button class="btn btn-primary float-right">Salvar</button>
        </div>

        <alert-message class='alert-danger' timeout="0"  :show="hasError"   :message="errorMessage"></alert-message>
        <alert-message class='alert-success' :show="hasSuccess" :message="successMessage"></alert-message>

      </form>
    </div>
  </div>

</div>

</template>

<script>
import moment from 'moment';
export default {
  name: 'UsersNew',
  data() {
    return {
      moment: moment,
      hasSuccess: false,
      hasError: false,
      errorMessage: '',
      hasSuccess: false,
      successMessage: '',
      validatePassword: false,
      form: {
        login: '',
        email: '',
        role: 'usuario',
        password: '',
        passwordConfirm: '',
        blocked: false,
        qtdDays: 30,
        expiraEm: moment().add(30, 'days').format('YYYY-MM-DD'),
        form: {
          peso: '',
          altura: '',
          cintura: 90,
          sexo: 10,
          imc: 0,
          nivel: 0,
          texto: '',
          tipoD: 'oms',
          mais: 2,
          medio: 1,
          menos: 0,
          manha: -1,
          tarde: -1,
          noite: -1,
          totais: {
            kcal: 0,
            c: 0,
            g: 0,
            gs: 0,
            p: 0,
            f: 0,
            na: 0
          },
          totaisPerc: {
            g: { perc: 0, passou: false },
            gs: { perc: 0, passou: false },
            c: { perc: 0, passou: false },
            p: 0
          },
        }
      }
    }
  },
  methods: {
    atualizaData() {
      console.log(this.form.qtdDays);
      this.form.expiraEm = moment().add(this.form.qtdDays, 'days').format('YYYY-MM-DD');
    },
    getTotalCotas() {
      const totalCotas =
        parseInt(this.form.form.manha) +
        parseInt(this.form.form.tarde) +
        parseInt(this.form.form.noite);

      return totalCotas;
    },
    getCotas() {
      if (this.form.form.mais == '0' && this.form.form.menos == '1') {
        this.form.form.medio = '2';
      }

      if (this.form.form.mais == '0' && this.form.form.menos == '2') {
        this.form.form.medio = '1';
      }

      if (this.form.form.mais == '0' && this.form.form.menos == '0') {
        this.form.form.menos = '2';
        this.form.form.medio = '1';
      }

      if (this.form.form.mais == '1' && this.form.form.menos == '0') {
        this.form.form.medio = '2';
      }

      if (this.form.form.mais == '1' && this.form.form.menos == '2') {
        this.form.form.medio = '0';
      }

      if (this.form.form.mais == '1' && this.form.form.menos == '1') {
        this.form.form.medio = '0';
        this.form.form.menos = '2';
      }

      if (this.form.form.mais == '2' && this.form.form.menos == '0') {
        this.form.form.medio = '1';
      }

      if (this.form.form.mais == '2' && this.form.form.menos == '1') {
        this.form.form.medio = '0';
      }

      if (this.form.form.mais == '2' && this.form.form.menos == '2') {
        this.form.form.medio = '0';
        this.form.form.menos = '1';
      }

      if (this.form.form.menos == '0' && this.form.form.mais == '1') {
        this.form.form.medio = '2';
      }

      if (this.form.form.menos == '0' && this.form.form.mais == '2') {
        this.form.form.medio = '1';
      }

      if (this.form.form.menos == '0' && this.form.form.mais == '0') {
        this.form.form.menos = '2';
        this.form.form.medio = '1';
      }

      const niveis = [4, 8, 16, 32, 64, 128, 256];

      if (
        this.form.form.peso &&
        this.form.form.altura &&
        this.form.form.cintura &&
        this.form.form.sexo
      ) {
        this.form.form.imc = (this.form.form.peso / (this.form.form.altura / 100 * (this.form.form.altura / 100))).toFixed(2);
        this.form.form.imc = this.form.form.imc / 1;

        if (this.form.form.imc < 17) {
          this.form.form.nivel = 6; //0
          this.form.form.texto = 'MUITO ABAIXO DO PESO';
        } else if (this.form.form.imc >= 17 && this.form.form.imc < 18.5) {
          this.form.form.nivel = 5; //128
          this.form.form.texto = 'ABAIXO DO PESO';
        } else if (this.form.form.imc >= 18.5 && this.form.form.imc < 25) {
          this.form.form.nivel = 4; //64
          this.form.form.texto = 'PESO NORMAL';
        } else if (this.form.form.imc >= 25 && this.form.form.imc < 30) {
          this.form.form.nivel = 3; //32
          this.form.form.texto = 'ACIMA DO PESO';
        } else if (this.form.form.imc >= 30 && this.form.form.imc < 35) {
          this.form.form.nivel = 2; //16
          this.form.form.texto = 'OBESIDADE GRAU 1';
        } else if (this.form.form.imc >= 35 && this.form.form.imc < 40) {
          this.form.form.nivel = 1; //8
          this.form.form.texto = 'OBESIDADE GRAU 2';
        } else if (this.form.form.imc >= 40) {
          this.form.form.nivel = 0; //4
          this.form.form.texto = 'OBESIDADE GRAU 3';
        }

        const e = this.form.form.cintura / niveis[this.form.form.nivel];
        const g = this.form.form.imc - e + parseInt(this.form.form.sexo);
        const dist = ['manha', 'tarde', 'noite'];

        if (this.form.form.sexo.toString() === '10') {
          this.form.form.turbinado = 0.5;
        } else {
          this.form.form.turbinado = 0.4;
        }

        if (g > 0) {
          this.form.form[dist[this.form.form.mais]] = (g * parseFloat(this.form.form.turbinado)).toFixed(0);
          this.form.form[dist[this.form.form.medio]] = (g * 0.36).toFixed(0);
          this.form.form[dist[this.form.form.menos]] = (g * 0.23).toFixed(0);
        }
      }
    },
    save() {
      if (!this.form.name) {
        this.hasError = true
        this.errorMessage = 'Preencha o nome.';
        return false;
      }

      if (!this.form.email) {
        this.hasError = true
        this.errorMessage = 'Preencha o email.';
        return false;
      }

      if (!this.form.form.peso || !this.form.form.altura || !this.form.form.cintura) {
        this.hasError = true
        this.errorMessage = 'Preencha os dados de peso, altura e cintura.';
        return false;
      }

      if((!this.form.password) || (this.form.password != this.form.passwordConfirm && this.validatePassword == true)) {
        this.hasError = true
        this.errorMessage = 'Inform the password and login.Password and password confirm must be equals.';
      } else {
        this.hasError = false;
        this.$http.post('v1/usuario', this.form).then((response) => {
          if (response.data.success) {
            this.hasSuccess = true;
            this.successMessage = 'New user created.';
            setTimeout(() => {
              this.$router.push('/users');
            }, 100);
          } else {
            this.errorMessage = response.data.err;
            this.hasError = true;
          }
        });
      }
    },
    passwordChanged() {
      this.validatePassword = true;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/UsersNew.vue